import { Avatar, AvatarGroup } from "@mui/material";
import type { ChannelMemberResponse } from "stream-chat";

type Props = {
  otherMembers: Array<ChannelMemberResponse>;
};

/**
 * A group conversation's avatar in the channel header: the first few members, stacked. (The
 * channel list shows a group as one icon instead — ChatGroupAvatar.)
 */
export const ChatHeaderGroupAvatar = ({ otherMembers }: Props) => (
  <AvatarGroup
    max={3}
    sx={{
      flexShrink: 0,
      "& .MuiAvatar-root": {
        width: 32,
        height: 32,
        fontSize: 14,
        borderColor: "primary.main",
      },
    }}
  >
    {otherMembers.map(({ user_id, user }) => (
      <Avatar key={user_id} src={user?.image} alt={user?.name ?? user_id} />
    ))}
  </AvatarGroup>
);
